<template>
  <div>
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="width: 1200px; padding-bottom: 0;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>机制币送评</span>收费标准</div>
        </div>
      </div>
    </div>
    <div style="background-color: #FFFAF4; padding: 50px 0;">
      <div style="width: 1200px; margin: 0 auto;">
        <p class="p-ty" style="padding: 0 40px; margin-bottom: 50px;">计费规则:按钱币真品公允市场估值分为6档收费，无论最终鉴定真假，评级服务费正常收取;送评人低估市值，水石评级有权按实际市价
上调收费档位。</p>
        <!-- <div class="table-box" style="padding-bottom: 50px;">
          <table>
            <thead>
              <tr>
                <th>档位</th>
                <th>单枚市场估值区间</th>
                <th>单枚评级费用(元)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1档</td>
                <td>估值<1000元</td>
                <td>50</td>
              </tr>
             <tr>
                <td>2档</td>
                <td>1000元≤估值<5000元</td>
                <td>100</td>
              </tr>
              <tr>
                <td>3档</td>
                <td>5000元≤估值<20000元</td>
                <td>150</td>
              </tr>
              <tr>
                <td>4档</td>
                <td>20000元≤估值<50000元</td>
                <td>300</td>
              </tr>
              <tr>
                <td>5档</td>
                <td>50000元≤估值<100000元</td>
                <td>1000</td>
              </tr>
              <tr style="border-bottom: 1px solid #DBB052;">
                <td>6档</td>
                <td>估值>100000元</td>
                <td>藏品估价x1.5%</td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <img src="@/assets/image/shoufei-yinyuan.png" alt="" style="width: 1200px; margin: 0 auto 60px auto;" />
        <!-- 附件 -->
        <ul class="fu-list" style="padding: 0 40px; margin-top: 50px;">
          <li>备注：</li>
          <li class="fu-item" v-for="item in beiZhuList">{{ item }}</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      beiZhuList: [
        '1.钱币估值为该钱币真品的公允市场估值;',
        '2.批量优惠:单次同品类送评》50枚9折，>200枚8折(仅限1档);',
        '3.复检服务费:原盒完好复检，复检结果和初评一致收取复检费;结果不一致由水石评级承担费用。'
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.shoufei-title{
  font-size: 28px;
  font-weight: bold;
  color: #907B47;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.shoufei-4{
  display: flex;
  align-items: center;
  border: 1px solid #DDAF58;
  padding: 0 150px 0 50px;
  height: 80px;
  line-height: 78px;
  position: relative;
  div{
    font-size: 16px;
    span{
      font-size: 26px;
      font-weight: bold;
      padding-right: 30px;
    }
  }
  img{
    width: 120px;
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}
.fu-list{
  margin-top: 80px;
}
.fu-item{
  letter-spacing: 1px;
  font-size: 16px;
  margin: 5px 0;
  line-height: 30px;
}
</style>